import { request } from '@/utils/request'
import { APP_ROLE_DISPATCH } from '@/constants/appRole'

/** 会员短信场景（对应后端 SmsSceneEnum） */
export const SMS_SCENE = {
  MEMBER_LOGIN: 1,
  MEMBER_UPDATE_MOBILE: 2,
  MEMBER_UPDATE_PASSWORD: 3,
  MEMBER_RESET_PASSWORD: 4
}

/** 手机号 + 密码登录（调度端 appRole=4） */
export function passwordLogin(mobile, password, appRole = APP_ROLE_DISPATCH) {
  return request({
    url: '/member/auth/login',
    method: 'POST',
    data: {
      mobile,
      password,
      appRole
    }
  })
}

/** 发送手机验证码 */
export function sendSmsCode(mobile, scene, appRole = APP_ROLE_DISPATCH) {
  const payload = {
    mobile,
    scene
  }
  if (scene === SMS_SCENE.MEMBER_RESET_PASSWORD) {
    payload.appRole = appRole
  }
  return request({
    url: '/member/auth/send-sms-code',
    method: 'POST',
    data: payload
  })
}

/** 退出登录 */
export function logout() {
  return request({
    url: '/member/auth/logout',
    method: 'POST'
  })
}
